<template>
  <base-section
  id="registration"
  >
    <v-container>
    <base-section-heading
    title="Registration"
    color="secondary"
    align="left"
    :toColor="true"
    >
    To register at LATS 2027 the first step is to fill out the registration <a href="https://docs.google.com/forms/d/e/1FAIpQLSdUFPccWMmgwb6t8nHk8yCJrPbJHpcAvP2lyZ0GKesTLza3Ng/viewform?usp=dialog" target="_blank">FORM</a>.
    <br>
    The registration will be processed after the registration fee payment confirmation.
    <br>
    The registration fee can be paid by credit card, or, for Brazilians*, by PIX (<a href="https://docs.google.com/document/d/15iaiBZcuvJZarwOqh7xTvrNL76LYcTSnkP0gYBrMxx4/edit?usp=sharing" target="_blank">click here for further instructions</a>).
    <br>
    For credit card payment please use the link corresponding to the appropriate registration category, indicated below. Note that there are two payment options using the links: (1) Credit card ("cartão de crédito") or (2) Debit card ("cartão de débito"). However, if you are not from Brazil, please use the option (1).
    <br><br>
    * Para pagamento por PIX há um desconto de R$ 100,00 a ser aplicado sobre o valor correspondente da tabela (para maiores detalhes, <a href="https://docs.google.com/document/d/15iaiBZcuvJZarwOqh7xTvrNL76LYcTSnkP0gYBrMxx4/edit?usp=sharing" target="_blank">clique aqui</a>).

    <br></br>
    <strong>The advance registration deadline is January 29th.</strong>
  </base-section-heading>

    <base-section-heading
    title="Payment Using Credit Card"
    color="secondary"
    align="left"
    :toColor="true"
    >
      <v-data-table
        :headers="headers"
        :items="features"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:item.advanceLink="{ item }">
          <a v-if="item.advanceLink" :href="item.advanceLink" target="_blank">Payment Link</a>
          <span v-else>{{ item.advanceLink || 'TBD' }}</span>
        </template>
        <template v-slot:item.lateLink="{ item }">
          <a v-if="item.lateLink" :href="item.lateLink" target="_blank">Payment Link</a>
          <span v-else>{{ item.lateLink || 'TBD' }}</span>
        </template>
      </v-data-table>

      <div style="margin-top: 20px;">
        <p><strong>The payment will be charged in BRL (Brazilian Reais).</strong></p>
        <p>The approximate currency (December, 2025) is:</p>
        <ul>
          <li>1.00 USD = 5.50 BRL</li>
          <li>1.00 EUR = 6.50 BRL</li>
        </ul>
      </div>

      <div style="margin-top: 20px;">
        <p style="font-size: 0.9em;">
          <sup>1</sup> The "Professional IEEE Member", "Professional Non-Member" and "Invited Speakers, IEEE Fellows Members, etc" registration fees include lunches, from March 18th – 20th, coffee-breaks, Welcome Cocktail, Social Event and Gala Dinner.
        </p>
        <p style="font-size: 0.9em;">
          <sup>2</sup> Invited speakers are those giving a Keynote, a Visionary Talk, an Invited Talk, an Industrial Talk or a Tutorial.
        </p>
        <p style="font-size: 0.9em;">
          <sup>3</sup> The "Student IEEE Member" and "Student Non-Member" registration fees includes lunches, from March 18th – 20th, coffee-breaks, and Welcome Cocktail. Student Registration Fees do not include Social Event & Gala Dinner.
        </p>
      </div>
    </base-section-heading>

    <base-section-heading
    title="Extra Tickets"
    color="secondary"
    align="left"
    :toColor="true"
    >
      <p>If you want to purchase extra tickets for lunches, cocktail, social event or gala dinner, for a companion, contact the organization at <a href="mailto:tiago.balen@ufrgs.br">tiago.balen@ufrgs.br</a> (copying <a href="mailto:paulo.butzen@ufrgs.br">paulo.butzen@ufrgs.br</a>) informing the required quantities.</p>
      <p>Fees for extra tickets will be soon available on this page. After receiving the requests we will manage to provide an additional payment link when necessary.</p>
    </base-section-heading>

    <base-section-heading
    title="Refund Policy"
    color="secondary"
    align="left"
    :toColor="true"
    >
      <p>Requests for refunds received before February 27th, 2026 will be subject to a USD 120.00 processing fee. No refunds will be made for cancellations received after February 27th, 2026, and all registration fees will be forfeited.</p>
    </base-section-heading>

    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Registration',

    data: () => ({
      headers: [
        {
          text: 'Category',
          value: 'category',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Advance Registration (BRL) - Until January 29th',
          value: 'advancePrice',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Links',
          value: 'advanceLink',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Late/On-Site Registration (BRL)',
          value: 'latePrice',
          sortable: false,
          align: 'right',
        },
        {
          text: 'Links',
          value: 'lateLink',
          sortable: false,
          align: 'center',
        },
      ],
      features: [
        {
          category: 'Professional IEEE Members ¹',
          advancePrice: 'BRL 3500.00',
          advanceLink: 'https://cielolink.com.br/4keiJpq',
          latePrice: 'BRL 4000.00',
          lateLink: 'https://cielolink.com.br/4keiJpq',
        },
        {
          category: 'Professional Non-Member ¹',
          advancePrice: 'BRL 4000.00',
          advanceLink: 'https://cielolink.com.br/46lHBWj',
          latePrice: 'BRL 4500.00',
          lateLink: 'https://cielolink.com.br/46lHBWj',
        },
        {
          category: 'Invited Speakers, IEEE Fellow Members, etc. ²',
          advancePrice: 'BRL 3000.00',
          advanceLink: 'https://cielolink.com.br/3NUcBGy',
          latePrice: 'BRL 3500.00',
          lateLink: 'https://cielolink.com.br/3NUcBGy',
        },
        {
          category: 'Student IEEE Members ³',
          advancePrice: 'BRL 1500.00',
          advanceLink: 'https://cielolink.com.br/4bkPw9R',
          latePrice: 'BRL 2000.00',
          lateLink: 'https://cielolink.com.br/4bkPw9R',
        },
        {
          category: 'Student Non-Member ³',
          advancePrice: 'BRL 2000.00',
          advanceLink: 'https://cielolink.com.br/4rjIQNJ',
          latePrice: 'BRL 2500.00',
          lateLink: 'https://cielolink.com.br/4rjIQNJ',
        },
      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

/* Remove border from last column */
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
  border-right: none;
}
</style>
